import Goodwe from './Goodwe';
import Growatt from './Growatt';
import Solax from './Solax';
import SunSpec from './SunSpec';
import AlphaESS from './AlphaESS';
import Huawei from './Huawei';
import SMA from './SMA';
import Solis from './Solis';
import SolarEdge from './SolarEdge';
import Victron from './Victron';
import Fronius from './Fronius';
import MTEC from './M-TEC';
import Sigenergy from './Sigenergy';
import Solinteg from './Solinteg';
import FoxEss from './Fox-ESS';
import Autarco from './Autarco';

export default {
  Fronius,
  Goodwe,
  Growatt,
  Huawei,
  'M-TEC': MTEC,
  Solax,
  SMA,
  Solis,
  SolarEdge,
  SunSpec,
  AlphaESS,
  Victron,
  Sigenergy,
  Solinteg,
  'Fox-ESS': FoxEss,
  Autarco,
};

export const CloudFlexConverters = {
  Enphase: {},
};
